import { Button } from '..'
import type { ButtonProps } from '../Button'
import { iconStyle } from './index.css'

export const Icon = (
  props: {
    src: string
    alt?: string
  } & ButtonProps,
) => {
  const { src, alt, ...buttonProps } = props
  return (
    <Button
      variant='reset'
      {...buttonProps}
    >
      <img
        src={props.src}
        className={iconStyle}
        alt={props.alt}
      />
    </Button>
  )
}
